import { AzureMapAddress, AzureMapPosition } from '@shared/components/azure-map/azure-map.model';

export type AddressModel = {
  locationId: number;
  locationName: string;
  address: string;
  lat: number;
  lon: number;
  postalCode?: string;
  countryCode?: string;
  countrySubdivisionCode?: string;
  countrySubdivisionName?: string;
  countrySecondarySubdivision?: string;
  city?: string;
  street?: string;
  isGlobal?: boolean;
};

export const DefaultAddress: AddressModel = {
  locationId: undefined,
  locationName: '',
  address: '',
  lat: 0,
  lon: 0,
  postalCode: '',
  countryCode: '',
  countrySubdivisionCode: '',
  countrySubdivisionName: '',
  countrySecondarySubdivision: '',
  city: '',
  street: '',
  isGlobal: false,
};

export const getAddressModelFromAzureMapAddressAndPosition = (address: AzureMapAddress, position: AzureMapPosition) => {
  return {
    address: address.freeformAddress,
    postalCode: address.postalCode,
    countryCode: address.countryCode,
    countrySubdivisionCode: address.countrySubdivisionCode,
    countrySubdivisionName: address.countrySubdivisionName,
    countrySecondarySubdivision: address.countrySecondarySubdivision,
    street: address.streetName ?? address.street,
    city: address.municipality ?? address.localName,
    lat: position.lat,
    lon: position.lon,
  } as AddressModel;
};
